import React from 'react';

// The Founderboard Coin mark (public/founderboard-coin.svg). Takes the same
// `size` / `className` props as a Phosphor icon so it can sit in any icon slot
// (admin nav, module registry); `weight` is accepted and ignored.
// eslint-disable-next-line no-unused-vars
const FounderboardCoinIcon = ({ size = 20, className = '', title, weight, ...rest }) => (
  <img
    src="/founderboard-coin.svg"
    width={size}
    height={size}
    alt={title || ''}
    aria-hidden={title ? undefined : true}
    draggable={false}
    className={`inline-block shrink-0 select-none ${className}`}
    {...rest}
  />
);

export default FounderboardCoinIcon;
